import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Logo from '../SmartEvacLogo.jpg';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useNavigate } from 'react-router-dom';
import { createUserWithEmailAndPassword } from "firebase/auth";
import {app, auth} from './Firebase.js';
import React, { useState } from 'react';


function Register() {
  const navigate = useNavigate(); 

  const handleReturn = (event) => {
    event.preventDefault();
    navigate('/'); 
  };

  return (
    <Container fluid className="app-container">
      <Row>
        <Col>
        <img className="app-logo" src={Logo} width="400" height="50"></img>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col xs={12} sm={8} md={6} lg={4}>
        <h1>Registration Successful</h1>
        <h2>Your request is under review. Our support team will get back to you shortly with an update.</h2>
        <p className="SignUpIndicator">
            <span className="SignUpQuestion">Return to</span>
            <a href="#" onClick={handleReturn}>Login</a>
        </p>
        </Col>
      </Row>
    </Container>
  );
}

export default Register;